module.exports = __webpack_public_path__ + "assets/icon-project-available-to-others-deselected.062dfe4b.svg";